import type { ReactNode } from 'react';

import {
    Dialog,
    DialogCloseButton,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '@nesso/ui/primitives/dialog';

type Props = {
    open: boolean;
    onOpen: (open: boolean) => void;
    trigger: ReactNode;
    children: ReactNode;
};

export function TranscriptDetailsDialog({ open, onOpen, trigger, children }: Props) {
    return (
        <Dialog open={open} onOpenChange={onOpen}>
            <DialogTrigger asChild>{trigger}</DialogTrigger>
            <DialogContent className="bg-card" fullscreen showCloseButton={false}>
                <div className="flex flex-col h-full overflow-hidden">
                    <DialogHeader className="flex flex-row text-left items-center justify-between p-6">
                        <DialogTitle>Session transcript</DialogTitle>
                        <DialogCloseButton onClick={() => onOpen(false)} className="self-start" />
                    </DialogHeader>

                    {children}
                </div>
            </DialogContent>
        </Dialog>
    );
}
